import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AdministrationSubdistrictActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Subdistrict/SubdistrictBrowser")
	}

	render() {
		return (
			<Activity 
				name="AdministrationSubdistrict"
				RenderedComponent={this.RenderedComponent}
				context="AdministrationSubdistrict"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AdministrationSubdistrictActivity)
